import { FaCheckCircle } from "react-icons/fa";
import CareerImage from "../../assets/images/career-image.jpg";
import "./career.css";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet";


export default function Career() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>

      <Helmet>
        <title>SHOP.CO | Careers - Join Our Team</title>
        <meta
          name="description"
          content="Explore career opportunities at SHOP.CO. Join our growing team and be part of shaping the future of online shopping."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/company/career/"
        />
      </Helmet>

      <div className="career-container">

        <section className="career-hero">
          <div className="career-hero-content">
            <h1>Build the Future of Online Shopping</h1>
            <p>Join our growing eCommerce team and help shape a brand that reaches thousands daily.</p>
            <Link to="/company/career/openRoles" className="career-btn">View Open Roles</Link>
          </div>
          <img
            src={CareerImage}
            alt="Career in ecommerce"
            className="career-hero-img"
          />
        </section>

        <section className="career-why">
          <h2>Why Work With Us?</h2>
          <ul className="career-benefits">
            <li><FaCheckCircle /> Dynamic environment focused on fashion & customer joy</li>
            <li><FaCheckCircle /> Opportunities in logistics, marketing, support & more</li>
            <li><FaCheckCircle /> Discounts on all our latest collections</li>
            <li><FaCheckCircle /> Be part of a creative, forward-thinking brand</li>
          </ul>
        </section>

        {/* Open Positions */}
        <section className="career-jobs">
          <h2>Current Openings</h2>
          <div className="career-job-cards">
            <div className="career-job-card">
              <h3>Customer Support Agent</h3>
              <p>Help customers with orders, returns, and general questions.</p>
              <a className="career-apply-btn" href="mailto:hr@yourdomain.com">Apply Now</a>
            </div>
            <div className="career-job-card">
              <h3>Product Photographer</h3>
              <p>Shoot and edit high-quality images of our latest styles.</p>
              <a className="career-apply-btn" href="mailto:hr@yourdomain.com">Apply Now</a>
            </div>
            <div className="career-job-card">
              <h3>Warehouse Assistant</h3>
              <p>Pack and ship orders with care and speed.</p>
              <a className="career-apply-btn" href="mailto:hr@yourdomain.com">Apply Now</a>
            </div>
            <div className="career-job-card">
              <h3>Marketing Coordinator</h3>
              <p>Promote our brand via social media & email campaigns.</p>
              <a className="career-apply-btn" href="mailto:hr@yourdomain.com">Apply Now</a>
            </div>
          </div>
        </section>

        <section className="career-cta">
          <h2>Didn’t find your role?</h2>
          <p>We're always open to meeting people passionate about eCommerce.</p>
          <a className="career-btn" href="mailto:hr@yourdomain.com">Send Us Your CV</a>
        </section>
      </div>

    </>
  );
}
